import { call, put, takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../../constants/ActionTypes/Authentication/SignIn_SignUp_Auth'
import { _GETUSERBOCACCOUNTDETAILS } from '../Web/Customer/GetUserBOCIdByADB2CId';
import i18next from 'i18next';
import { getLocalSessionData, setLocalSessionData } from '../../utils/Authentication/handleUserSession';
import { LOCALSESSIONDATAKEYS, SIGNUPTYPE, SUCCESS } from '../../constants/AppConstants';
import { _USERROLESSERVICE } from '../../store/UserRoles/UserRolesSaga';
import { userRoles } from '../../constants/UserRoles';
import { UserEnrolledDevicesServiceInit } from '../../store/UserEnrolledDevices/UserEnrolledDevicesSlice';

function* handleError(msg = null) {
    yield put({
        type: actionTypes.APP_SIGN_IN_SERVICE_ERROR,
        message: (msg) ? msg : i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR")
    })
}

/**
 * This method calls the API to fetch the user user roles
 * 
 * Logic
 *  - The user can have any role; Customer, Admin, CSAgentAdmin, CSAgentViewer etc
 *  - On response, if the user has "Customer" role then GetUserEnrolledDevices API will be invoked
 *  - On response, if the role array is empty (for new users) then also GetUserEnrolledDevices API will be invoked
 *  - (GetUserEnrolledDevices API will be invoked to check the maximum enrolled device limit of a customer)
 *  - Since this saga is only used by MobileConnect and LandingPageLogin, always dispatch HandleLoginIn success action
 * 
 * @param {string} userId 
 * @param {string} signupType 
 * @param {object} deviceId
 * 
 * @returns void
 */
function* call_GetUserRoles(userId, signupType, deviceId) {
    try {
        var isNonCustomerRole = false;
        const adb2cId = getLocalSessionData(LOCALSESSIONDATAKEYS.AZURE_AD_B2C_UID);
        const userRolesInfo = yield call(_USERROLESSERVICE, userId, adb2cId);
        if (userRolesInfo.actionStatus.toUpperCase() === SUCCESS) {
            if (userRolesInfo.roles.length === 0 || userRolesInfo.roles.includes(userRoles.CUSTOMER)) {
                yield put(UserEnrolledDevicesServiceInit({
                    doEnrolmentCheck: true,
                    doDeviceExistCheck: (deviceId !== null && deviceId !== undefined) ? true : false,
                    doLoginRedirectionCheck: signupType === SIGNUPTYPE.LANDINGPAGE_LOGIN ? true : false
                }));
            } else {
                isNonCustomerRole = true;
            }
            /** dispatch HandleLoginIn Success action */
            yield put({ type: actionTypes.APP_SIGN_IN_SERVICE_SUCCESS, IsNonCustomerRole: isNonCustomerRole })

        } else {
            yield* handleError();
        }

    } catch (e) {
        yield* handleError(e.message);
    }
}

/**
 * This method calls the API to fetch the BOC UserID using the ADB2CID
 * 
 * Logic
 *  - If the response has UserdID, the next action GetUserRole API is dispatched
 *  - IF the response does not have UserID, the extenal validation process follows until UserId is obtained.
 * 
 * @param {object} action 
 * @returns void
 */
function* call_GetBOCUserIdByADB2CID(action) {
    try {
        const signupType = action.signUpType;
        const deviceId = action.deviceId ?? null;
        const bocUserIdInfo = yield call(_GETUSERBOCACCOUNTDETAILS);
        const userId = bocUserIdInfo.userId;
        setLocalSessionData(LOCALSESSIONDATAKEYS.UID, userId);
        (userId)
            ? yield* call_GetUserRoles(userId, signupType, deviceId)
            : yield put({ type: actionTypes.APP_SIGN_IN_SERVICE_SUCCESS, BOC_NO_UserID_Err: true })
    } catch (e) {
        /**
        * This conditional statement is added to avoid
        * displaying error message in view while logout from app
        */
        if (e instanceof TypeError === false && e.message !== "401") {
            yield* handleError(e.message);
        }
    }

}

function* SignIn_Auth() {
    yield takeEvery(actionTypes.APP_SIGN_IN_SERVICE_INIT, call_GetBOCUserIdByADB2CID);
}

export default SignIn_Auth;
export { call_GetUserRoles }